import { WysiwygFormBlock } from 'models/common/form/formContentBlock/WysiwygFormBlock';

export default class WysiwygFormBlockService {
	toModel(formBlock) {
		return new WysiwygFormBlock(formBlock);
	}
}
